// Site content data for Gawkari Hillside
// Scraped from https://gawkari.com

export const pillarCards = [
    {
        title: "Marathi Ashmita (मराठी अस्मिता)",
        subtitle: "Reconnect with Your Heritage",
        icon: "🏛️",
        points: [
            "Traditional welcomes with Gandh, Gulal, and Aarti",
            "Folk music performances – Powada, Lavani, Gondhal",
            "Stories of Shivaji Maharaj and local legends",
            "Cultural programs celebrating Maharashtrian traditions"
        ]
    },
    {
        title: "Grameen Jeevan (ग्रामीण जीवन)",
        subtitle: "Experience Authentic Village Living",
        icon: "🌾",
        points: [
            "Wake up to rooster calls and bird songs",
            "Watch farmers tend their fields and orchards",
            "Participate in daily village activities",
            "Connect with the rhythm of rural life"
        ]
    },
    {
        title: "Modern Aaram (आधुनिक आराम)",
        subtitle: "Contemporary Comfort in Traditional Settings",
        icon: "✨",
        points: [
            "Comfortable accommodations with modern bathrooms",
            "Swimming pool for relaxation and family fun",
            "WiFi connectivity whenever you need it",
            "All modern amenities in rustic settings"
        ]
    }
];

export const accommodationOptions = [
    {
        name: "Traditional Wada Rooms",
        description: "Experience authentic Maharashtrian architecture with all modern conveniences. Our wada-style rooms feature traditional wooden elements, vintage décor, and the warmth of heritage hospitality.",
        features: [
            "Four spacious rooms with traditional interiors",
            "Modern attached bathrooms with running hot water",
            "Traditional wooden furniture and flooring",
            "AC and Non-AC options",
            "Room service and tea/coffee maker"
        ],
        idealFor: "Heritage lovers & couples"
    },
    {
        name: "Hillside Cottages",
        description: "Private cottages offering stunning valley views and the serenity of hillside living. Wake up to bird songs and mountain mists.",
        features: [
            "Six independent cottages with private sit-outs",
            "Panoramic hillside views",
            "Modern amenities in rustic settings",
            "Attached bathrooms and mini-fridge",
            "Complimentary breakfast"
        ],
        idealFor: "Nature enthusiasts & privacy seekers"
    },
    {
        name: "Family Suites",
        description: "Spacious suites designed for multi-generational families. Enough room for everyone to stay together and create memories.",
        features: [
            "Three large suites with two bedrooms and a living area",
            "Two bathrooms for added convenience",
            "Separate sitting area and extra mattress options",
            "Ideal for grandparents, parents, and children"
        ],
        idealFor: "Large families & group stays"
    }
];

export const diningIntro = "Every meal at Gawkari is a celebration of authentic flavors, prepared with love using traditional recipes passed down through generations.";

export const diningPhilosophy = [
    "Farm-fresh ingredients from our own fields",
    "Traditional recipes passed down generations",
    "Pure vegetarian kitchen",
    "Seasonal and locally sourced produce",
    "Cooked with love by local village women"
];

export const diningMenus = [
    {
        title: "Maharashtrian Meals",
        items: [
            "Authentic Maharashtrian Thali with daily vegetables",
            "Pithla–Bhakri / Zunka–Bhakri with rice",
            "Varan–Bhaat, Amti, papad, pickles, and chutney",
            "Traditional dal-rice combinations",
            "Seasonal vegetable preparations"
        ]
    },
    {
        title: "Snacks & Breakfast",
        items: [
            "Misal Pav",
            "Kanda Poha",
            "Sabudana Khichdi",
            "Thalipeeth with white butter",
            "Fresh chai and coffee"
        ]
    },
    {
        title: "Sweets & Special Items",
        items: [
            "Puran Poli",
            "Ukdiche Modak (seasonal)",
            "Shrikhand",
            "Aamras (seasonal)",
            "Jaggery-based desserts"
        ]
    }
];

export const dessertShowcase = [
    {
        title: "Ukadiche Modak",
        description: "Steamed rice flour dumplings filled with coconut and jaggery, offered to Ganpati and savoured warm with ghee.",
        image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&w=400&q=80",
        ingredients: ["Freshly grated coconut", "Desi cow ghee drizzle", "Sourced jaggery from nearby farms"]
    },
    {
        title: "Puran Poli & Katachi Amti",
        description: "Sweet chana dal flatbread paired with a tangy-spiced lentil broth—our festive comfort combo.",
        image: "https://images.unsplash.com/photo-1567337710282-00832b415979?auto=format&fit=crop&w=400&q=80",
        ingredients: ["Stone-ground spices", "Hand-kneaded dough", "Seasonal jaggery variations"]
    },
    {
        title: "Shrikhand & Amrakhand",
        description: "Hung curd whipped with cardamom, saffron, and Alphonso pulp for the perfect chilled finale.",
        image: "https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=400&q=80",
        ingredients: ["House-made hung curd", "Saffron from Pune", "Seasonal mango purée"]
    }
];

export const beverageHighlights = [
    {
        title: "Sol Kadhi",
        description: "Cooling kokum-coconut digestif served after hearty meals, balancing spice with tang.",
        image: "https://images.unsplash.com/photo-1544145945-f90425340c7e?auto=format&fit=crop&w=400&q=80",
        ingredients: ["Cold-pressed coconut milk", "Wild kokum", "Tempered with cumin"]
    },
    {
        title: "Masala Taak",
        description: "Spiced buttermilk churned each morning with fresh herbs from the farm.",
        image: "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?auto=format&fit=crop&w=400&q=80",
        ingredients: ["Stone-ground masala", "Organic curd", "Cooling summer staple"]
    },
    {
        title: "Hillside Herbal Kadha",
        description: "Warm infusion of lemongrass, tulsi, and jaggery—perfect for misty evenings.",
        image: "https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&w=400&q=80",
        ingredients: ["Homegrown herbs", "Slow-steeped", "Immunity booster"]
    }
];

export const idealForGroups = [
    {
        title: "Tent Stays",
        description: "Experience camping under the stars with comfortable tent accommodations",
        icon: "⛺"
    },
    {
        title: "Room Stays",
        description: "Traditional wada-style rooms with modern amenities",
        icon: "🏠"
    },
    {
        title: "Camping Spots",
        description: "Dedicated camping areas with bonfire arrangements",
        icon: "🏕️"
    },
    {
        title: "Nature Views",
        description: "Wake up to stunning Sahyadri mountain views",
        icon: "🏔️"
    },
    {
        title: "Short Trips",
        description: "Perfect for day picnics and weekend getaways",
        icon: "🚗"
    },
    {
        title: "Night Stays",
        description: "Experience the magic of starlit village nights",
        icon: "🌙"
    }
];

export const galleryCategories = [
    { name: "Accommodation", count: 12 },
    { name: "Dining", count: 8 },
    { name: "Nature", count: 15 },
    { name: "Experiences", count: 10 },
    { name: "Events", count: 6 }
];

export const galleryImages = [
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908943/WhatsApp_Image_2025-12-14_at_5.56.05_PM_zortcw.jpg",
        alt: "Gawkari hillside room interior",
        category: "Accommodation",
        location: "Wada Room"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908943/WhatsApp_Image_2025-12-14_at_5.55.59_PM_1_mzwcs0.jpg",
        alt: "Traditional room with wooden furniture",
        category: "Accommodation",
        location: "Heritage Suite"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908942/WhatsApp_Image_2025-12-14_at_5.56.05_PM_1_jjold4.jpg",
        alt: "Cozy cottage interior",
        category: "Accommodation",
        location: "Hillside Cottage"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908940/WhatsApp_Image_2025-12-14_at_5.56.03_PM_wadhse.jpg",
        alt: "Family suite bedroom",
        category: "Accommodation",
        location: "Family Suite"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908938/WhatsApp_Image_2025-12-14_at_5.55.55_PM_p5o2hf.jpg",
        alt: "Traditional dining area",
        category: "Dining",
        location: "Restaurant"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1765908936/WhatsApp_Image_2025-12-14_at_5.56.01_PM_1_yrtkiu.jpg",
        alt: "Nature view from property",
        category: "Nature",
        location: "Garden View"
    },
    {
        src: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=600&q=80",
        alt: "Sahyadri mountains view",
        category: "Nature",
        location: "Mountain View"
    },
    {
        src: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=600&q=80",
        alt: "Forest trail at Gawkari",
        category: "Nature",
        location: "Nature Walk"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545057/WhatsApp_Image_2026-01-04_at_7.15.40_PM_1_fsnpil.jpg",
        alt: "Fresh strawberries at the farm",
        category: "Experiences",
        location: "Strawberry Farm"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545057/WhatsApp_Image_2026-01-04_at_7.15.40_PM_ffiq9y.jpg",
        alt: "Strawberry picking experience",
        category: "Experiences",
        location: "Farm Activity"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545058/WhatsApp_Image_2026-01-04_at_7.15.41_PM_eyfqce.jpg",
        alt: "Juicy strawberries ready for harvest",
        category: "Experiences",
        location: "Strawberry Fields"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545060/WhatsApp_Image_2026-01-04_at_7.15.42_PM_btaabt.jpg",
        alt: "Enjoying fresh strawberries",
        category: "Experiences",
        location: "Farm Visit"
    },
    {
        src: "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545060/WhatsApp_Image_2026-01-04_at_7.15.41_PM_1_qntzzz.jpg",
        alt: "Strawberry parcel service box",
        category: "Experiences",
        location: "Farm Produce"
    }
];

export const aboutSataraIntro = [
    "Gawkari Hillside is more than just an agro-tourism destination—it's a return to your roots. Nestled in the serene Sahyadri hills of Satara district, Maharashtra, our property offers an authentic glimpse into traditional Maharashtrian village life.",
    "Founded with a vision to preserve and share the rich cultural heritage of rural Maharashtra, Gawkari provides guests with immersive experiences that connect them with the land, its people, and age-old traditions.",
    "Our name 'Gawkari' comes from the Marathi word for village lifestyle. Here, you'll find the perfect blend of rustic charm and modern comfort, where every morning begins with bird songs and every meal tells a story of our land."
];

export const aboutSataraHighlights = [
    {
        title: "Our Location",
        points: [
            "Located in Satalewadi village, near Parkhandi",
            "Just 20km from Satara city",
            "Easy access from Pune (120km) and Mumbai (280km)",
            "Surrounded by the scenic Sahyadri mountain range"
        ]
    },
    {
        title: "Our Philosophy",
        points: [
            "Sustainable and eco-friendly practices",
            "Supporting local farmers and artisans",
            "Preserving traditional Maharashtrian culture",
            "Farm-to-table dining experiences"
        ]
    },
    {
        title: "What We Offer",
        points: [
            "Authentic village stay experiences",
            "Traditional Maharashtrian cuisine",
            "Cultural performances and activities",
            "Nature walks and farm tours"
        ]
    }
];

export const signatureExperiencesData = [
    {
        title: "Farm-to-Table Journey",
        tagline: "From field to fork",
        description: "Experience the complete journey of your food—from harvesting vegetables in our organic farm to cooking them with traditional methods.",
        details: [
            {
                heading: "Activities Included",
                items: [
                    "Morning farm tour with our farmers",
                    "Vegetable and herb harvesting",
                    "Traditional cooking class",
                    "Lunch with your own harvest"
                ]
            }
        ]
    },
    {
        title: "Cultural Evening",
        tagline: "Heritage under the stars",
        description: "Immerse yourself in Maharashtrian culture with folk performances, traditional games, and stories around the bonfire.",
        details: [
            {
                heading: "Evening Program",
                items: [
                    "Powada and Lavani performances",
                    "Traditional village games",
                    "Bonfire with local snacks",
                    "Stargazing session"
                ]
            }
        ]
    },
    {
        title: "Nature Trails",
        tagline: "Explore the Sahyadris",
        description: "Guided walks through the scenic landscapes, exploring local flora, fauna, and hidden waterfalls.",
        details: [
            {
                heading: "Trail Options",
                items: [
                    "Sunrise hill trek",
                    "Bird watching walk",
                    "Waterfall hike (seasonal)",
                    "Village heritage walk"
                ]
            }
        ]
    }
];

export const siteMetadata = {
    brandName: "Gawkari Hillside",
    shortName: "Gawkari",
    description: "Gawkari is a modern agro-tourism getaway offering immersive farm stays, day picnics, and curated experiences inspired by rural living.",
    siteUrl: "https://gawkari.com",
    keywords: [
        "Gawkari",
        "agro tourism",
        "farm stay",
        "eco resort",
        "day picnic",
        "Satara agro tourism",
        "rural experiences",
        "Maharashtrian hospitality",
        "village stay",
        "nature retreat"
    ],
    contact: {
        phone: "+91 92846 36553",
        email: "contact@gawkari.com",
        address: "At Satalewadi, Post Parkhandi, Satara, Maharashtra - 412803"
    }
};
